import 'slick';

( function( $ ) {
	'use strict';
	const slide = $( '.news-events__item' );

	//check for more than 2 items before init slider
	if ( 2 < slide.length ) {
		$( '.news-events__slider' ).slick( {
			arrows: true,
			dots: false,
			infinite: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			speed: 300,
			mobileFirst: true,
			swipe: true,
			fade: false,
			autoplay: false,
			adaptiveHeight: true,
			prevArrow:'<div class=\'mts-prev\'>',
			nextArrow:'<div class=\'mts-next\'>',
			responsive: [
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 2
					}
				}
			]
		} );
	}
} )( jQuery );
